import { BaseOptionType } from '@rc-component/select/lib/Select';
import { AntSelectPropsGeneric, AntSelectValue } from 'controls/react/ant/ant-select/types';

export function getLabelField<VT extends AntSelectValue, OptionType extends BaseOptionType>(
	props: AntSelectPropsGeneric<VT, OptionType>,
) {
	return props.fieldNames?.label ?? 'label';
}
